import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import SortableTable from '../../molecules/SortableTable';
import { Action, Label, TableRow } from '../../atoms';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import Icon from '../../atoms/Icon';

interface ReportingDetailsVerificationStatusesOrganismProps {
  data: VerificationStatusResponseDto[];
  handleDeleteVerificationStatus: (id: string) => void;
}

const ReportingDetailsVerificationStatusesOrganism: FC<
  ReportingDetailsVerificationStatusesOrganismProps
> = ({ data, handleDeleteVerificationStatus }) => {
  const navigate = useNavigate();

  const handleUpdateVerificationStatus = (id: string) => {
    navigate(`/reporting-details/verification-statuses/${id}/edit`);
  };

  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Logo', key: 'logoUrl' },
        { label: 'Verification Status', key: 'name' },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Icon size={'xxs'} imageUrl={row.logoUrl ?? ''} />
          <Label content={row.name} />
          <Action
            type="edit"
            size="sm"
            onClick={() => handleUpdateVerificationStatus(row.id)}
          />
          <Action
            type="delete"
            itemName={row.name}
            size="sm"
            onClick={() => handleDeleteVerificationStatus(row.id)}
          />
        </TableRow>
      )}
    />
  );
};

export default ReportingDetailsVerificationStatusesOrganism;
